import { createSelector } from 'reselect';
import { identity, get, map, compose, uniqBy, concat } from 'lodash/fp';
import {
    ApplicationState,
    ProfileData,
    isEnterpriseProfileData,
    isIntegrationProfileData,
    isPersonalProfileData,
} from '@mews-commander/types';
import { getStringProp } from '@mews/fp';
import { composeProps, createPropsExtender } from '@mews/framework';
import { getOrEmptyArray } from '@mews-commander/utils';
import { getThreadOriginalSender } from '@mews-commander/legacy-entities/src/ducks/threads';
import { getThreadMembershipProfileIds } from '@mews-commander/legacy-entities/src/ducks/threadsMembership';
import { getSimpleUser } from '@mews-commander/legacy-entities/src/ducks/simpleUsers';
import { getProfileIsActive, getProfileData } from '@mews-commander/legacy-entities/src/ducks/profiles';
import { moduleSelector } from '../module';
import { getCurrentThreadId } from './threads';

const membersSelector = createSelector(moduleSelector, get('members'));
export const loadingMembersSelector = createSelector(moduleSelector, get('loadingMembers'));

const getThreadDraftMembers = createSelector(getStringProp('id'), membersSelector, getOrEmptyArray);

const isUserProfile = (profileData: $TSFixMe) =>
    isEnterpriseProfileData(profileData) || isPersonalProfileData(profileData);

export const getThreadMembers = createSelector(
    getThreadMembershipProfileIds,
    getThreadDraftMembers,
    getThreadOriginalSender,
    identity,
    (threadMembershipProfileIds, threadDraftMembers, originalSender, state: ApplicationState) =>
        compose(
            uniqBy('profileId'),
            concat(threadDraftMembers),
            // @ts-expect-error $TSFixMeError: No overload matches this call.
            map((id: string) => {
                const profileData = getProfileData(state, { id }) as ProfileData | null;
                const isActive = getProfileIsActive(state, { id });
                const isEmployee = profileData ? isEnterpriseProfileData(profileData) : false;

                const user =
                    profileData && isUserProfile(profileData)
                        ? getSimpleUser(state, { id: (profileData.value as $TSFixMe).userId })
                        : {};

                const sender =
                    profileData && isIntegrationProfileData(profileData) ? { firstName: originalSender } : {};

                return {
                    isActive,
                    isEmployee,
                    profileId: id,
                    ...user,
                    ...sender,
                };
            })
            // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
        )(threadMembershipProfileIds)
);

export const getCurrentThreadMembers = composeProps(getThreadMembers, createPropsExtender('id', getCurrentThreadId));
